import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MobileTabsModel } from '@fi-app/utilities/mobile-tabs/mobile-tabs.model';
import { AppTextService } from '@fi-shared/app-text';
import { MobileTabModel } from '@fi-app/utilities/mobile-tabs/mobile-tab.model';
import { NewsFeedService } from '@fi-app/news-feed/news-feed.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { Subject } from 'rxjs';
import { FiSignalRHelperService } from '@fi-shared/fi-signal-r/fi-signal-r-helper.service';
import { takeUntil } from 'rxjs/operators';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-home',
    template: `
        <div class="home-page fi-container mobile-tab-{{ MobileTabs.Tabs[MobileTabs.SelectedIndex].PropertyName }}">
            <fi-mobile-tabs class="MediaBankMobileTabs" [tabsModel]="MobileTabs"></fi-mobile-tabs>

            <div (fiWhenScrolled)="homeWhenScrolled()" class="fi-content" fi-scroll-root>
                <fi-start-page-layout
                    [widgetAdministrate]="widgetAdministrate"
                    [widgetAdministrateWidgets]="widgetAdministrateWidgets"
                    (onHomeWhenScrolled)="homeWhenScrolled()"
                ></fi-start-page-layout>
            </div>
        </div>
    `,
    standalone: false,
})
export class FiHomeComponent implements OnInit, OnDestroy {
    @Input() widgetAdministrate;
    @Input() widgetAdministrateWidgets;

    MobileTabs: MobileTabsModel;

    constructor(
        private appTextService: AppTextService,
        private newsFeedService: NewsFeedService,
        private pageTitleService: PageTitleService,
        private fiSignalRHelperService: FiSignalRHelperService,
        private userDataService: FiUserDataService,
        private fiStateService: FiStateService,
    ) {}

    ngOnInit() {
        this.MobileTabs = new MobileTabsModel(this.appTextService.get('common.home'));
        this.MobileTabs.Tabs.push(new MobileTabModel(this.appTextService.get('common.home'), 'HomeTab'));
        this.MobileTabs.Tabs.push(new MobileTabModel(this.appTextService.get('common.more'), 'MoreTab'));
        this.updatePageTitle();
        this.fiSignalRHelperService.newNewsFeeds$
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe(() => this.updatePageTitle());
        this.userDataService.activeSiteDesignChanged$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => {
            this.fiStateService.go(FiStateNames.Home._name, undefined, { reload: true });
        });
    }

    private updatePageTitle() {
        const pageTitle = this.appTextService.get('common.home');
        const newNewsFeedsCount = this.fiSignalRHelperService.getNewNewsFeedsCount();
        this.pageTitleService.setTitle(pageTitle, newNewsFeedsCount ? `(${newNewsFeedsCount})` : undefined);
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    homeWhenScrolled() {
        this.newsFeedService.raiseHomeTabScrolled();
    }
}
